<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Módosítás'"
      placement="top"
      v-can="'settings.packtype.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updatePackType"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'settings.packtype.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deletePackType"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props: ['packType'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },
    methods: {
      async deletePackType() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('packType/delete', this.packType.id);
          this.$store.dispatch('packType/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updatePackType() {
        this.$router.push('/lists/pack-types/update/' + this.packType.id);
      }
    }
  };
</script>
